export const PDP_EVENTS = {
  PAGELOAD: 'pdp_view',
  SIZE_CHART_CLICK: 'size_chart_click',
  PDP_CHAT_BTN_CLICK: 'pdp_chat_btn_click',
  PDP_OFFER_CLICK: 'pdp_offer_click',
  ON_REVIEW_PAGELOAD: 'pdp_review_page',
  SIZE_SELECTOR_LOADED: 'size_selector_loaded',
  PDP_CHANGE_DELIVERY_PINCODE: 'pdp_change_delivery_pincode',
  EVENT_ON_PDP_CHECK_DELIVERY: 'pdp_check_delivery',
  BRAND_NAME_CLICKED: 'visit_brand_click',
  INFO_SECTION_CLICKED: 'pdp_details_section_click',
  COUPON_CLICKED: 'pdp_coupon_click',
  ECOM_CLICKED: 'pdp_ecom_policy_click',
  REVIEW_PAGE_LOADED: 'pdp_review_page',
  CAROUSEL_FIRST_IMAGE_SWIPED: 'pdp_carousal_image_scrolled',
  PDP_BACK_BUTTON_CLICKED: 'pdp_back_clicked',
  ADD_TO_CART: 'add_to_cart',
  SIZE_CHART_CLOSED: 'size_chart_closed',
  EXCHANGE_RETURN_POLICY_CLICKED: 'pdp_return_policy_opened',
  PDP_COLOR_SELECTED: 'pdp_color_selected',
  PDP_OOS_VARIANT_SEEN: 'pdp_size_out_of_stock_variant_seen',
  REVIEWS_VIEWED: 'pdp_reviews_scrolled',
  NUDGE_CONTINUE_CLICK: 'nudge_continue_click',
};

export const SIMPLE = 'simple';

export enum BRAND_CLICK_TRACK_LOCATION {
  DESIGNER_IMAGE_CLICK = 'productDetailPage:aboutBrand',
  VIEW_BRAND_CTA = 'productDetailPage:viewBrandCTA',
  TITLE_CLICK = 'productDetailPage:visitBrand',
}
